import { FC } from "react"
// import DataSetIcon from "../../icons/harmonization/DataSetIcon"
import InfoIcon from "../../icons/harmonization/InfoIcon"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import CustomDropdown from "./CustomDropdown"
// import DatasetTable from "./dataset/DatasetTable"
import MultiSelectDropdown from "./MultiselectDropdown"
import {
  // Box,
  SelectChangeEvent,
  // Typography
} from "@mui/material"
import {
  getDatasetTable,
  setDataset,
  setSelectedColumns,
} from "./HarmonizationSlice"
import DataSetIconDp from "../../icons/harmonization/DataSetIconDp"

interface IDataSetCompProps {
  id: number
  title: string
}

// const mappedData = (row: any, column: string[]) => {
//   return row.map((r: any) => {
//     const obj: any = {}
//     column.forEach((col) => {
//       obj[col] = r[col]
//     })
//     return obj
//   })
// }

const DataSetComp: FC<IDataSetCompProps> = ({ id, title }) => {
  const dispatch = useAppDispatch()
  const { datasetList, dataset1, dataset2 } = useAppSelector(
    (state) => state.harmonization,
  )
  // const tableData = id === 1 ? dataset1.data : dataset2.data
  const tableColumns = id === 1 ? dataset1.columns : dataset2.columns
  const selectedColumns =
    id === 1 ? dataset1.selectedColumns : dataset2.selectedColumns
  const selectedDataset =
    id === 1 ? dataset1.selectedDataset : dataset2.selectedDataset

  // const mappedTableData = mappedData(tableData, selectedColumns)

  const handleChangeDataset = (e: SelectChangeEvent) => {
    dispatch(setDataset({ datasetName: e.target.value, datasetCompId: id }))
    dispatch(
      getDatasetTable({ datasetName: e.target.value, datasetCompId: id }),
    )
  }

  const handleSelectionChange = (selected: string[]) => {
    dispatch(
      setSelectedColumns({ selectedColumns: selected, datasetCompId: id }),
    )
  }
  return (
    <div className="bg-[#FCFCFC] rounded-md px-4 py-5 flex flex-1 gap-3">
      {/* left */}
      <div className="flex flex-col w-full gap-4">
        {/* top dataset-panel */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5">
            <DataSetIconDp />
            <p className="font-bold text-[16px]">{title}</p>
          </div>

          <div className="relative group">
            <div className="">
              <InfoIcon />
            </div>
            {/* <div className="absolute left-0 mt-2 hidden group-hover:block bg-white text-black p-2 shadow-lg rounded">
              info
            </div> */}
          </div>
        </div>

        <div className="flex flex-col gap-1.5">
          <p className="text-xs font-bold">
            Select Dataset<span className="text-dpTheme-main ml-[1px]">*</span>
          </p>
          <CustomDropdown
            label="Select Dataset"
            value={selectedDataset}
            options={datasetList}
            onChange={handleChangeDataset}
            disabledOption={
              id === 1 ? dataset2.selectedDataset : dataset1.selectedDataset
            }
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <p className="text-xs font-bold">Select Columns</p>
          {/* <CustomDropdown
            
          /> */}
          <MultiSelectDropdown
            options={tableColumns}
            selectedValues={selectedColumns}
            onChange={handleSelectionChange}
          />
        </div>
      </div>

      {/* right */}
      {/* <Box
        sx={{
          overflowX: "auto",
          scrollbarWidth: "thin",
          pr: 0.5,
        }}
        className="flex-1 grid grid-cols-1 gap-4 custom-scrollbar"
      >
        {selectedColumns.length === 0 ? (
          <Box
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "tableColors.body",
            }}
          >
            <Typography>Select a data set to Map and populate</Typography>
          </Box>
        ) : (
          <DatasetTable columns={selectedColumns} data={mappedTableData} />
        )}
      </Box> */}
    </div>
  )
}

export default DataSetComp
